/* METTA — trackpad scrolling for the frontpage product carousels.

   A trackpad's sideways gesture does nothing to these rows on its own: the
   theme bundles Swiper without its Mousewheel module, so there is no
   swiper.mousewheel to switch on and the only way through a row is its arrows.

   Driving it from wheel events instead also lets the axis rule be explicit:
   only a gesture that is more horizontal than vertical is taken. Anything else
   belongs to the page, and a carousel that swallows vertical scroll whenever
   the pointer crosses it is worse than one that does not scroll at all. */

(() => {
  if (!document.body.classList.contains('template-index')) return;

  const SELECTOR = '.featured-collection-slider__content.swiper';

  const enableTrackpad = (element) => {
    const swiper = element.swiper;
    if (!swiper) return false;
    if (element.dataset.mettaTrackpad) return true;
    element.dataset.mettaTrackpad = 'true';

    let settle;

    const onWheel = (event) => {
      if (swiper.destroyed) return;
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;

      // At either end, hand the gesture back so the browser's own
      // swipe-to-navigate still works.
      const atStart = swiper.translate >= swiper.minTranslate() && event.deltaX < 0;
      const atEnd = swiper.translate <= swiper.maxTranslate() && event.deltaX > 0;
      if (atStart || atEnd) return;

      event.preventDefault();

      const next = Math.min(
        Math.max(swiper.translate - event.deltaX, swiper.maxTranslate()),
        swiper.minTranslate(),
      );

      swiper.setTransition(0);
      swiper.setTranslate(next);
      swiper.updateProgress(next);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();

      // Snap once the fingers lift, so the row never rests mid-card.
      clearTimeout(settle);
      settle = setTimeout(() => {
        if (!swiper.destroyed) swiper.slideToClosest(400);
      }, 120);
    };
    element.addEventListener('wheel', onWheel, { passive: false });
    swiper.on('destroy', () => {
      clearTimeout(settle);
      element.removeEventListener('wheel', onWheel);
      delete element.dataset.mettaTrackpad;
    });

    return true;
  };

  const run = (root = document) =>
    root.querySelectorAll(SELECTOR).forEach((element) => enableTrackpad(element));

  // Hidden collection tabs may initialize long after page load. The section
  // announces readiness, so they need neither frame polling nor a timeout.
  document.addEventListener('metta:carousel:ready', (event) => {
    if (event.target.matches(SELECTOR)) enableTrackpad(event.target);
  });

  run();
  window.addEventListener('load', () => run());

  // Theme editor re-renders a section from scratch.
  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();
